export const API_URL = process.env.API_URL || "http://localhost:8080";
export const SOCKETS_URL = process.env.SOCKETS_URL || "ws://localhost:8080";
export const NODE_ENV = process.env.NODE_ENV || "development";
